// 모든 화면에서 공통으로 사용하는 페이지 레이아웃
// title: 화면명, toolbar: 조회조건 영역, children: 그리드 영역, message: 하단 메시지
import React from 'react';
import './PageLayout.css';

const PageLayout = ({ title, toolbar, children, message, scrollable }) => {
  const msgClass =
    message?.type === 'success' ? 'msg-success'
    : message?.type === 'error'   ? 'msg-error'
    : message?.type === 'warn'    ? 'msg-warn'
    : 'msg-info';

  return (
    <div className="page-layout">
      {/* 화면명 */}
      <div className="page-title-bar">
        <h2>{title}</h2>
      </div>

      {/* 조회 조건 */}
      {toolbar && (
        <div className="page-toolbar">{toolbar}</div>
      )}

      {/* 데이터 그리드 영역 */}
      <div className={`page-body${scrollable ? ' page-body-scroll' : ''}`}>
        {children}
      </div>

      {/* 하단 메시지 영역 - 레이아웃 고정, 메시지만 변경 */}
      <div className={`page-message-bar ${message?.text ? msgClass : ''}`}>
        {message?.text || ' '}
      </div>
    </div>
  );
};

export default PageLayout;
